@if (show) {
  <div [ngClass]="{ open: show }" class="growler {{ level }}" id="Growler">
    <div class="title">{{ title }}</div>
    <div class="subtitle">{{ subtitle }}</div>
    <div [innerHTML]="content" class="content"></div>
    <div class="icon"></div>
  </div>
}
